import { Producto } from "../../bussines/entities/Productos.entity";

export class ProductoModel implements Producto {
    constructor(
        public codigo: string,
        public denominacion: string,
    ) { }

    serialize(): Producto {
        return {
            codigo: this.codigo,
            denominacion: this.denominacion,
        }
    }

    static deserialize(entity: Producto): ProductoModel {
        return new ProductoModel(
            entity.codigo ?? '',
            entity.denominacion ?? '',
        );
    }
}